/* tslint:disable */
/* eslint-disable */
/**
 * Trendtours CMS API
 * ISO API for the IBE. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiWishlistProductsRequest
 */
export interface ApiWishlistProductsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiWishlistProductsRequest
     */
    productIds: Array<string>;
}

export function ApiWishlistProductsRequestFromJSON(json: any): ApiWishlistProductsRequest {
    return ApiWishlistProductsRequestFromJSONTyped(json, false);
}

export function ApiWishlistProductsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiWishlistProductsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productIds': json['productIds'],
    };
}

export function ApiWishlistProductsRequestToJSON(value?: ApiWishlistProductsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'productIds': value.productIds,
    };
}


// custom code here ##################################################################################################################
function toUTC(date) {
  var date_utc =  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
  return new Date(date_utc);
}
